import React from "react";
import "./CourseSection.css";
import { Link } from "react-router-dom";

const courses = [
  { name: "Software Engineering", image: "/se_main.png", year: "3rd Year", path: "/subject-SEModules" },
  { name: "Embedded Systems", image: "/es_main.png", year: "3rd Year", path: "/subject-ESModules" },
  { name: "Cryptography And Network Security", image: "/cns_main.png", year: "3rd Year", path: "/subject-CNSModules" },
  { name: "DAA", image: "/DAA2.png", year: "2nd Year", path: "/subject-DAAModules" },
  { name: "TOC", image: "/TOC3.png", year: "2nd Year", path: "/subject-TOCModules" },
  { name: "MPMC", image: "/Mpmc.jpg", year: "2nd Year", path: "/subject-MPMCModules" },

];

const CourseCard = ({ name, image, year, path }) => (
  <li>
    <div className="course-card">
      <figure className="card-banner img-holder" style={{ "--width": 370, "--height": 220 }}>
        <img src={image} width="370" height="220" loading="lazy" alt={name} className="img-cover" />
      </figure>
      <div className="card-content">
        <span className="badge">{year}</span>
        <h3 className="h3">{name}</h3>
        <Link to={path} className="btn has-before">
          <span className="span">Start Learning</span>
        </Link>
      </div>
    </div>
  </li>
);

const CourseSection = () => {
  return (
    <section className="section course" id="courses" aria-label="course">
      <div className="container">
        <p className="section-subtitle">Choose Your Subject!</p>
        <h2 className="h2 section-title">Pick a Subject and get started!</h2>
        <ul className="grid-list">
          {courses.map((course, index) => (
            <CourseCard key={index} {...course} />
          ))}
        </ul>
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Link to="/courses" className="btn has-before">
            <span className="span">Explore More Courses</span>
          </Link>
        </div>

      </div>
    </section>
  );
};

export default CourseSection;
